import React, { forwardRef } from 'react';
import BaseCurrencyInput from 'react-currency-input-field';
import { IntlConfig } from 'react-currency-input-field/src/components/CurrencyInputProps';
import classnames from 'classnames';
import { useSelector } from 'react-redux';
import { StoreInterface } from '../../store/types';

interface Props {
  id?: string;
  value: string | number | undefined;
  onChange: (value: string | number | undefined) => void;
  disabled?: boolean;
  intlConfig?: IntlConfig;
  className?: string;
}

const CurrencyInput = forwardRef((props: Props, ref) => {
  const { value, onChange, disabled, intlConfig, id, className } = props;

  const { company } = useSelector((state: StoreInterface) => state.initialData);
  const currency = company?.currency ?? 'EUR';

  return (
    <BaseCurrencyInput
      id={id}
      value={value}
      disabled={disabled}
      defaultValue="0.00"
      onValueChange={onChange}
      decimalSeparator="."
      disableGroupSeparators
      intlConfig={
        intlConfig ?? {
          locale: 'en',
          currency,
        }
      }
      transformRawValue={(value) => value.replace(',', '.')}
      ref={ref as React.Ref<HTMLInputElement>}
      className={classnames('w-full p-sm rounded bg-gray-500 font-sm', className)}
    />
  );
});

export default CurrencyInput;
